import React from 'react';
import Header from './Common/header';
import './css/index';

export default class Content_flash extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@36ve6u`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div id="flash_play_574" style={{ width: '100%', height: '300px', overflowY: 'hidden' }}>
                                    <embed width="100%" height="300px" wmode="opaque" name="plugin" src="/page/resource/userfile/image/elementPrew/imgSlide/MULTIpIC.png" type="application/x-shockwave-flash" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_flash.js